import React, { useRef, useState } from 'react';

const Section9 = ({ imgWebp, imgJpg, videoSrc, videoPoster, imgAlt, title, subtitle, desc }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
      setIsPlaying(true);
    }
  };

  return (
    <section className="section-9">
      <div className="container full">
        <div className="row">
          <div className="col col-50">
            <div className="img-holder">
              {videoSrc ? (
                <div className="video-wrapper" onClick={handlePlay}>
                  <video ref={videoRef} width="100%" draggable="false" controls={isPlaying} playsInline preload="metadata" poster={videoPoster}>
                    <source src={videoSrc} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  {!isPlaying && (
                    <img className="play-icon" src="/img/play-icon.png" alt="Play Video" />
                  )}
                </div>
              ) : (
                <picture>
                  <source type="image/webp" srcSet={imgWebp} />
                  <source type="image/jpeg" srcSet={imgJpg} />
                  <img src={imgWebp} alt={imgAlt} draggable="false" />
                </picture>
              )}
            </div>
          </div>

          <div className="col col-50">
            <div className="content-holder">
              <p className="subtitle">{subtitle}</p>
              <h3 className="title">{title}</h3>
              <div className="desc" dangerouslySetInnerHTML={{ __html: desc }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section9;